export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_640kbps-7bbc5df87ed10cc2d90e3515fa122212.avif";